import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

/**
 * Place this anywhere inside a HeaderBar to push its contents to the right.
 * Uses margin-left: auto on a flex child — no React magic required.
 *
 * @param {React.ReactNode} props.children
 * @param {string}          [props.className]
 */
const HeaderEnd = ({ children, className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)}>{children}</div>
  );
};

export default HeaderEnd;

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },
}));
